"use client";

import Image from "next/image";
import { useApp } from "@/forApp/states/appState/appState";
import Button from "@/shared/Buttons/Button";
import styles from "./styles.module.css";

interface ConsultationBannerProps {
	title: string;
	secondTitle?: string;
	description: string;
	buttonText: string;
	imageUrl: string;
	imageAlt: string;
	className?: string;
	widthImg?: number;
	heightImg?: number;
}

export default function ConsultationBanner({
	title,
	secondTitle,
	description,
	buttonText,
	imageUrl,
	imageAlt,
	widthImg,
	heightImg,
	className = "",
}: ConsultationBannerProps) {
	const { addModal, isMobile } = useApp();
	const onButtonClick = () => {
		addModal({ name: "ConsultationModal", title: "Заказать звонок", from: "" });
	};

	return (
		<section
			className={`${styles.banner} ${className}`}
			aria-labelledby="consultation-title"
		>
			<div className={styles.content}>
				<div className={styles.textContent}>
					<h2 id="consultation-title" className={styles.title}>
						{title}
						{secondTitle ? (
							<>
								<br />
								{secondTitle}
							</>
						) : (
							""
						)}
					</h2>
					<p className={styles.description}>{description}</p>
					<Button
						onClick={onButtonClick}
						aria-describedby="consultation-title"
						text={buttonText}
						color={"dark"}
						className={styles.openBtn}
					/>
				</div>

				<div className={styles.imageContainer}>
					{isMobile ? (
						<Image
							src={imageUrl}
							alt={imageAlt}
							fill
							sizes={"100vw"}
							className={styles.imageFill}
							priority={false}
						/>
					) : (
						<Image
							src={imageUrl}
							alt={imageAlt}
							width={widthImg ? widthImg : 300}
							height={heightImg ? heightImg : 200}
							className={styles.image}
							priority={false}
						/>
					)}
				</div>
			</div>
		</section>
	);
}
